import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const HeadContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled.h3`
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  text-align: left;
`

export const IconArrow = styled(Button)``